import React from 'react';
import { useApp } from '../../context/AppContext';

export const BusinessFilter = () => {
  const { currentUser, businessLines, selectedBusiness, setSelectedBusiness } = useApp();
  const userBizIds = currentUser?.assigned_businesses || [];
  const userLines = businessLines.filter(l => userBizIds.includes(l.id));
  const displayLines = userLines.length > 0 ? userLines : businessLines;

  if (displayLines.length === 0) return null;

  return (
    <div data-testid="business-filter" className="flex items-center gap-1.5 bg-white border border-slate-200 rounded-lg p-1">
      {displayLines.map(line => {
        const isActive = selectedBusiness === line.id;
        return (
          <button
            key={line.id}
            data-testid={`biz-filter-${line.name}`}
            onClick={() => setSelectedBusiness(line.id)}
            className={`px-3 py-1.5 rounded-md text-xs font-semibold transition-all whitespace-nowrap ${
              isActive
                ? 'text-white shadow-sm'
                : 'text-slate-500 hover:text-slate-700 hover:bg-slate-50'
            }`}
            style={isActive ? { backgroundColor: line.color } : {}}
          >
            {line.label}
          </button>
        );
      })}
    </div>
  );
};
